import React, { Component } from "react";
import { Modal, Button, Spin } from "antd";
import { router } from "umi";
import { getComposeUrl } from "../../../../../utils/common";
import { GetQueryString } from "../../../../../utils/utils";
import "./index.less";

let appId = GetQueryString("appId") || 40;

class TemplateModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      typeData: [
        {
          typeId: 0,
          title: "全部"
        }
      ]
    };
    appId = GetQueryString("appId") || 40;
  }

  componentDidMount() {
    const { typeList } = this.props;
    const tempTypeList = typeList || [];
    const tempTypeData = [
      {
        typeId: 0,
        title: "全部"
      }
    ];
    if (tempTypeList && tempTypeList.length) {
      tempTypeList.forEach(item => {
        tempTypeData.push({
          typeId: item.typeId,
          title: item.typeName && item.typeName.slice(0, 2)
        });
      });
    }
    this.setState({
      typeData: tempTypeData
    });
  }

  // 点击选中活动模板
  handleSelectTemplate = item => {
    const { handleSelectTemplate } = this.props;
    if (typeof handleSelectTemplate === "function") {
      handleSelectTemplate(item);
    }
  };

  // 修改模板tab
  handleChangeTab = typeId => {
    const { handleChangeTab } = this.props;
    if (handleChangeTab) {
      handleChangeTab(typeId);
    }
  };

  renderTemplateItem = () => {
    const { templateList } = this.props;
    return (
      <div className="templateItemWrapper">
        {templateList.map(item => {
          return (
            <div
              className="itemWrapper"
              onClick={() => this.handleSelectTemplate(item)}
              key={item.templateId}
            >
              <div className="templateTitle">
                <span className="templateItemIcon">
                  <img src={item.typeIcon} alt="" />
                </span>
                <div className="templateItemName">{item.templateName}</div>
              </div>
            </div>
          );
        })}
      </div>
    );
  };

  render() {
    const { modalProps, nowTypeId, loading } = this.props;
    const { typeData } = this.state;
    return (
      <Modal {...modalProps}>
        <Spin spinning={loading}>
          <div className="createButton">
            <Button
              type="primary"
              onClick={() =>
                router.push(
                  `${getComposeUrl("/activitySign/list/create")}?appId=${appId}`
                )
              }
            >
              + 创建新活动
            </Button>
          </div>
          <div className="tabContainer">
            {typeData.map(item => {
              return (
                <span
                  className={nowTypeId === item.typeId ? "selectedTab" : ""}
                  onClick={() => this.handleChangeTab(item.typeId)}
                >
                  {item.title}
                </span>
              );
            })}
          </div>
          <div className="contentWrapper">{this.renderTemplateItem()}</div>
        </Spin>
      </Modal>
    );
  }
}

export default TemplateModal;
